import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { PushNotificationService } from '../../shared/services/push-notification.service';
import { FooterComponent } from './shared/components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { filter, map } from 'rxjs';

@Component({
	selector: 'app-private',
	standalone: true,
	imports: [RouterOutlet, FooterComponent, CommonModule],
	template: `
		<div class="app-shell">
			<router-outlet />
			@if (showFooter()) {
				<app-footer></app-footer>
			}
		</div>
	`,
})
export class PrivateComponent implements OnInit {
	authService = inject(AuthService);
	pushNotificationService = inject(PushNotificationService);
	router = inject(Router);
	activatedRoute = inject(ActivatedRoute);

	showFooter = signal(true);

	ngOnInit() {
		this.pushNotificationService.initPush();
		this.updateFooterVisibility();

		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			this.updateFooterVisibility();
		});
	}

	private updateFooterVisibility() {
		let route = this.activatedRoute.root;
		while (route.firstChild) {
			route = route.firstChild;
		}

		const hideFooter = route.snapshot.data['hideFooter'];
		// Fallback check based on URL if data is missing for some reason
		const url = this.router.url;
		const isSpecialPage = url.includes('/dettaglio/') || url.includes('/firma-otp');

		this.showFooter.set(!hideFooter && !isSpecialPage);
	}
}
